<script setup lang="ts">
/**
 * A word in the navbar with a panel under it (费用, 工单), as the clouds'
 * are: a cell the bar's full height with a chevron that turns over while
 * the panel is out. The panel opens under the pointer and hangs from the
 * bar's rule beneath the cell's left edge, so the cell is its tab; a click
 * on the word is its own page. One panel out at a time (navPanel). The
 * panel itself, a .nav-panel, is the slot.
 */
import { computed, watch } from 'vue'
import { IconDown } from '@arco-design/web-vue/es/icon'
import { navPanel } from '@/utils/layout'

const props = defineProps<{ name: string; route: string; label: string }>()
const emit = defineEmits<{ open: [] }>()

const open = computed(() => navPanel.value === props.name)
function onVisible(v: boolean) {
  if (v) navPanel.value = props.name
  else if (open.value) navPanel.value = null
}
watch(open, (v) => {
  if (v) emit('open')
})
</script>

<template>
  <a-trigger
    :popup-visible="open"
    trigger="hover"
    position="bl"
    :popup-offset="1"
    :mouse-leave-delay="200"
    @popup-visible-change="onVisible"
  >
    <router-link :to="{ name: route }" class="nav-link" :class="{ open }">
      {{ label }}<IconDown class="chevron" />
    </router-link>
    <template #content>
      <slot />
    </template>
  </a-trigger>
</template>

<style scoped>
.chevron {
  margin-left: 4px;
  font-size: 12px;
  transition: transform 0.2s cubic-bezier(0.34, 0.69, 0.1, 1);
}
.open .chevron {
  transform: rotate(180deg);
}
</style>
